import { useEffect, useMemo, useRef } from 'react';
import {
  createMessageHistoryController,
  type MessageHistoryNavigation,
} from './createMessageHistoryController';
import {
  acquireMessageHistorySession,
  releaseMessageHistorySession,
} from './messageHistorySessionStore';

export type {
  MessageHistoryEntry,
  MessageHistoryMentionSnapshot,
  MessageHistoryNavigation,
} from './createMessageHistoryController';

export function useMessageHistory({
  sessionId,
}: {
  sessionId?: string;
} = {}): MessageHistoryNavigation {
  const fallbackRef = useRef<MessageHistoryNavigation | null>(null);

  const sessionController = useMemo(() => {
    if (!sessionId) {
      return null;
    }
    return acquireMessageHistorySession({ sessionId });
  }, [sessionId]);

  useEffect(() => {
    if (!sessionId) {
      return;
    }

    return () => {
      releaseMessageHistorySession({ sessionId });
    };
  }, [sessionId]);

  if (sessionController) {
    return sessionController;
  }

  if (fallbackRef.current === null) {
    fallbackRef.current = createMessageHistoryController();
  }

  return fallbackRef.current;
}
